module.exports = __webpack_public_path__ + "GB.png?8d7e0c569f553eeb5dcbc98a5811a811";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/GB.png
// module id = 55
// module chunks = 0